import { defineMessages } from 'react-intl';

export default defineMessages({
  UserAccessAccessEditMsgErr1: {
    defaultMessage: 'There was an error, please try again',
    id: 'user.access.accessEdit.msgErr1',
  },
  UserAccessAccessEditMsgSucc1: {
    defaultMessage: 'Access edited successfully',
    id: 'user.access.accessEdit.msgSucc1',
  },
  UserAccessAprtmDirect: {
    defaultMessage: 'Access directly to the apartment allowed',
    id: 'user.access.aprtmDirect',
  },
  UserAccessBtnValidityEdit: {
    defaultMessage: 'Change validity',
    id: 'user.access.btnValidityEdit',
  },
  UserAccessNoValidityLimit: {
    defaultMessage: 'No limit',
    id: 'user.access.noValidityLimit',
  },
  UserAccessValidityEditModalAprtmDirectLabel: {
    defaultMessage: 'Allow access directly to the apartment',
    id: 'user.access.validityEditmodal.aprtmDirect.label',
  },
  UserAccessValidityEnd: {
    defaultMessage: '<typography>to</typography> {validityEnd} ',
    id: 'user.access.validityEnd',
  },
  UserAccessValidityLabel: {
    defaultMessage: 'Access validity',
    id: 'user.access.validityLabel',
  },
  UserAccessValidityStart: {
    defaultMessage: '<typography>from</typography> {validityStart}',
    id: 'user.access.validityStart',
  },
});
